export default function Level(props) {
    return (
        <li className="dl-item" onClick={() => props.onClick(props.item)}>
            <img src={`./img/levels/${props.id}.png`} alt="" />
            <div className="dl-item-text">
                <h3>#{props.index} {props.name}</h3>
                <p>By {props.author}</p>
                <p className="dl-points">{(parseInt(props.points, 10) || 0) + 'pts'}</p>
            </div>
        </li>
    );
}